import { render } from "./elem-map.vue?vue&type=template&id=ae4a851c&ts=true"
import script from "./elem-map.vue?vue&type=script&lang=ts"
export * from "./elem-map.vue?vue&type=script&lang=ts"

import "./elem-map.vue?vue&type=style&index=0&id=ae4a851c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__